import api from '../api'

export default {
    namespaced:true,
    state:{
        complaintList:{
            beanList:[],
            total:0
        },
		userFeedbackList:{
		    beanList:[],
		    total:0
		}
    },
    mutations:{
        setStateComplaintList(state,info){
            state.complaintList = info
        },
		setuserFeedbackList(state,info){
            state.userFeedbackList = info
        }
  
	},
    actions:{
		getUserFeedbackList({commit},params){
		    return api.post('/messages/userFeedback/list','用户反馈',params).then(res=>{
		        commit('setuserFeedbackList',res.data)
		    })
		},
		updateUserFeedback(store,params){
		    return api.post('/messages/userFeedback/update','处理反馈',params)
		},
        getComplaintList({commit},params){
            return api.post('/complaint/list','投诉列表',params).then(res=>{
                commit('setStateComplaintList',res.data)
            })
        },
        updateComplaint(store,params){
            return api.post('/complaint/update','处理投诉',params)
        }
    }
}